import React from 'react';
import PropTypes from 'prop-types';
import css from './index.scss';
import { Profile } from '../../helpers/icon-dictionary';
import SvgIcon from '../svg-icon/svg-icon';

const StudentCount = ({ icon = '', count = 0 }) => {
    const iconStyle = icon === '' ? css.icon : icon;

    return (<div className={css.container}>
        <div className={iconStyle}><SvgIcon icon={Profile} /></div>
        <div className={css.count}>{count}</div>
    </div>);
};

StudentCount.propTypes = {
    count: PropTypes.number,
    icon: PropTypes.string
};

export default StudentCount;



// WEBPACK FOOTER //
// ./app/components/student-count/index.js